import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { EntityScreenComponent } from './entity-screen.component';
import { EntityBodyComponent } from '../entity-detail/entity-body.component';
import { EntityHeaderComponent } from '../entity-detail/entity-header.component';
import { TamDashboardModule } from '../tam-dashboard/tam-dashboard.module';
import { ResearchComponentModule } from '../research-component.module';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { CalendarScreenModule } from '../calendar-screen/calendar-screen.module';
import { EntityDetailModule } from '../entity-detail/entity-detail.module';
import { StoreModule } from '@ngrx/store';
import { entityReducer } from '../../tamalelibs/redux/entity.reducer';
import { EffectsModule } from '@ngrx/effects';
import { RecentNotesEffects } from '../../tamalelibs/redux/thread-list.effects';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        TamDashboardModule,
        ResearchComponentModule,
        TooltipModule,
        TreeViewModule,
        CalendarScreenModule,
        EntityDetailModule,
        StoreModule.forFeature('entity', entityReducer),
        EffectsModule.forFeature([RecentNotesEffects]),
    ],
    declarations: [
        EntityScreenComponent,
    ],
    exports: [
        EntityScreenComponent,
    ],
    providers: []
})
export class EntityScreenModule {

}
